import Box from "@mui/material/Box";
import GenericButton from "../../../../shared/ui/GenericButton";
import PageTitle from "../../../../shared/ui/PageTitle";
import {useAuth} from "../../../../hooks/useAuth";
import {Link, useLocation, useNavigate} from "react-router-dom";
import BoxContent from "../../../../shared/ui/BoxContent";
import {useRouteMatch} from "../../../../utils/functions";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ItemsActive from "../components/ItemsActive";
import ItemsArchived from "../components/ItemsArchived";

const CustomTestItems = () => {
    const {user} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(["/itemi-proprii", "/itemi-proprii/arhiva"]);
    const addItemHandler = () => {
        navigate(`/itemi-proprii/adauga`);
    };

    return (
        <Box>
            <PageTitle
                actions={
                    user.position === "teacher" ? (
                        <GenericButton
                            type="add"
                            onClick={() => {
                                addItemHandler();
                            }}
                        />
                    ) : (
                        ""
                    )
                }
            >
                Itemi proprii
            </PageTitle>
            <BoxContent>
                <Box sx={{width: "100%"}}>
                    <Box mb={2} sx={{borderBottom: 1, borderColor: "divider"}}>
                        <Tabs
                            value={currentTab}
                            sx={{
                                "& .MuiTabs-flexContainer": {
                                    flexWrap: "wrap",
                                },
                            }}
                        >
                            <Tab label="Itemi activi" value="/itemi-proprii" to="/itemi-proprii" component={Link}/>
                            <Tab
                                label="Itemi arhivați"
                                value="/itemi-proprii/arhiva"
                                to="/itemi-proprii/arhiva"
                                component={Link}
                            />
                        </Tabs>
                    </Box>
                    {location.pathname === "/itemi-proprii" && <ItemsActive/>}
                    {location.pathname === "/itemi-proprii/arhiva" && <ItemsArchived/>}
                </Box>
            </BoxContent>
        </Box>
    );
};

export default CustomTestItems;
